import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

export default function PopUpConsent({ openPopUp, closePopup }) {
  const handleClose = () => {
    closePopup(false);
  };

  return (
    <Dialog
      open={openPopUp}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <br />
      <DialogTitle id="alert-dialog-title" align="left">
        {"פורטל ללקוחות עסקיים קבוצת ניאופרם – תקנון ותנאי שימוש"}
      </DialogTitle>

      <DialogContent align="right">
        {/* <DialogContentText id="alert-dialog-description"> */}
        <p dir="rtl">
          {" "}
          ברוך הבא לפורטל הלקוחות העסקיים (להלן – "האתר") של החברה עמה התקשרת
          בהסכם ו/או של קבוצת ניאופרם (להלן – "החברה" ו"הקבוצה" בהתאמה), אשר
          נועד למתן שירותים מקוונים וריכוז מידע אדמיניסטרטיבי עבור לקוחות עסקיים
          שקיבלו הרשאה מהחברה לקבל גישה לאתר (להלן: "הלקוח" ו/או "הלקוחות").
          כניסה, ציפייה והשימוש באתר על תכניו והשירותים הניתנים בו, מאושרים על
          ידי החברה רק בכפוף לעמידה וקבלת כל תנאי השימוש המפורטים להלן ובנוסף
          בכפוף לכל מסמך ו/או הסכם עליו חתם הלקוח ועל כן יש לקרוא את תנאי השימוש
          שלהלן בעיון.
        </p>
        <br />
        <p>
          <strong>
            <u>כללי</u>
          </strong>
        </p>
        <ol dir="rtl" style={{ marginRight: "2.5rem" }}>
          <li>
            המידע באתר נועד למתן שירותים מקוונים וריכוז מידע אדמיניסטרטיבי.
          </li>
          <li>
            שימוש באתר ו/או בשירותיו מהווה הסכמה מצד הלקוח להוראות התקנון ולתנאי
            שימוש אלה ומהווים התחייבות מצידו לפעול בהתאם להם. יובהר, כי האתר
            והמידע בו ואינו משקף את מכלול המידע ו/או השירותים המוצעים על ידי
            החברה ו/או הקבוצה וייתכנו שירותים ו/או מידע נוסף שלא ניתן לצפות בהם
            ו/או לצרוך אותם באמצעות האתר.
          </li>
          <li>
            הקבוצה שומרת לעצמה את הזכות לשנות מעת לעת את האתר, לרבות הוספת ו/או
            גריעת שירותים ו/או שינוי הוראות השימוש והתנאים לשימוש באתר ו/או
            הפסקת פעילות האתר באופן מלא או חלקי, על-פי שיקול דעתה הבלעדי, וכל
            שינוי כאמור יחייב את הלקוח ממועד פרסומו באתר או ממועד קבלת הודעה על
            כך בדרך אחרת כלשהי, לפי המוקדם.{" "}
          </li>
          <li>
            המידע באתר כפוף לשינויים אשר החברה ו/או הקבוצה רשאים להחליט עליהם
            מעת לעת, לרבות תיקונו, ביטול או שינוי הפירוט במידע ו/או הצגתו ו/או
            תוכניות ו/או שירותים ו/או אפשרויות המופיעים באתר, ללא מתן הודעה
            מוקדמת ואף לפני עדכונם באתר וכן לשינויים על פי הוראות כל דין.
          </li>
          <li>
            ידוע ללקוח כי באפשרותו לפנות לחברה בבקשה לביטול הרישום לאתר ו/או
            לשירותים המקוונים וכי במקרה כזה תהיה החברה והקבוצה פטורה מכל אחריות
            ו/או חבות בגין חשיפת המידע לגורם שאינו מורשה.
          </li>
          <li>
            האתר והשירותים המקוונים שבו אינם כוללים תמיכה טכנית כלשהי, והחברה
            תשתדל לענות ככל שביכולתה לפניות הלקוח בעניינים טכניים שיתקבלו
            באמצעות פניות לשירות הלקוחות של החברה, ללא כל התחייבות מצידה לעשות
            כן.
          </li>
          <li>
            אתר זה עשוי להכיל קישורים לאתרי אינטרנט שאינם מופעלים ע"י הקבוצה,
            אלא בידי גורמים אחרים. אין לקבוצה שליטה על אתרים אלה, ואין הקבוצה
            נושאת באחריות לתכנים המופיעים בהם.
          </li>
        </ol>

        <br />
        <p>
          <strong>
            <u>כניסה והשימוש באתר</u>
          </strong>
        </p>
        <ol dir="rtl" style={{ marginRight: "2.5rem" }}>
          <li value="8">
            החברה תהא רשאית לאפשר גישה, ציפייה או שימוש באתר (ושימוש במלוא או
            חלק מן השירותים מסוימים בו), לפי שיקול דעתה הבלעדי ולכן האתר יהיה
            נגיש רק ללקוחות שיאושרו על ידי החברה כבעלת גישה אליו.
          </li>
          <li>
            מוסכם וידוע ללקוח ולאנשי הקשר המורשים מטעמו, כי לצורך קבלת חלק
            מהשירותים המקוונים הם רשאים למסור את פרטיהם, לרבות כתובת הדואר
            האלקטרוני ואת מספר הטלפון הנייד בפלטפורמות השונות של השירותים
            המקוונים, וכי הקבוצה ו/או החברה ו/או מי מטעמם יהיו רשאים לשלוח
            לכתובת הדואר האלקטרוני ו/או למספר הטלפון הנייד שנמסר כל הודעה ו/או
            תזכורת ו/או מידע על מידע או פרסום באתר.
          </li>
          <li>
            הכניסה לאתר תעשה רק באמצעות אנשי קשר מורשה על ידי החברה, אחד או
            יותר. הלקוח שיבקש גישה לאתר, ימסור לחברה את כל פרטי הקשר הנדרשים
            המלאים והנכונים של איש הקשר המבוקש על ידי הלקוח לקבל גישה לאתר וזה
            יאושר על ידי החברה לפי שיקול דעתה הבלעדי ובכפוף לקבלת כל המסמכים
            והפרטים הנדרשים. רק איש קשר מורשה של הלקוח כאמור יקבל הרשאות מטעם
            הלקוח לשימוש וציפייה באתר (להלן - "איש הקשר המורשה" או "אנשי הקשר
            המורשים").
          </li>
          <li>
            איש הקשר המורשה של הלקוח שיאושר על ידי החברה יוכל לבקש מהחברה הוספת
            אנשי קשר נוספים על ידי השלמת הבקשה באתר ומסירת כל פרטי קשר הנדרשים
            של אותם אנשי קשר נוספים של הלקוח, ואלו יאושרו בכפוף לשיקול הדעת
            הבלעדי של החברה.
          </li>
          <li>
            האחריות על שינוי ו/או עדכון ו/או מחיקה של איש הקשר המורשה ו/או
            הרשאות לעובדי הלקוח, עובדים לשעבר של הלקוח ו/או מי מטעמו של הלקוח,
            מוטלת באופן בלעדי על הלקוח בלבד.{" "}
          </li>
          <li>
            כניסה לאתר תבוצע על ידי הליך אישור זיהוי כפול (FA2), כך שאיש הקשר
            המורשה שיזין את פרטיו וסיסמתו בעמוד הכניסה לאתר יישלח לו קוד גישה חד
            פעמי למספר הטלפון הנייד של איש הקשר המורשה שיהיה עליו להזינו לאתר
            בתוך פרק זמן מוגדר. פרטי הזיהוי המאפשרים כניסה לאתר הינם אישיים
            וסודיים. אין להחזיקם במקום גלוי בו יהיו נגישים לאחרים.{" "}
          </li>
          <li>
            ידוע ללקוח שבתום כל שימוש באתר ו/או בשירותים המקוונים שבו מוטלת עליו
            האחריות הבלעדית להסיר את המידע ו/או את נתוני הזיהוי ו/או כל נתון אחר
            שעלולים לאפשר גישה למידע ו/או לשירות למי שאינם מורשים לכך, והלקוח
            פוטר/ת את החברה ו/או הקבוצה מכל אחריות ו/או חבות בגין כך.
          </li>
          <li>
            ידוע ללקוח ולאנשי הקשר המורשים מטעמו כי רגישות המידע המופיע באתר
            מחייבת אותו בשמירה קפדנית על הסיסמה האישית ועל פרטי הכניסה לאתר וכן
            על פרטי המשתמש בפורטל ו/או פרטי אנשי הקשר המורשים. על הלקוח לנקוט
            בכל האמצעים לשמירת הסיסמה והקוד הייחודי המאפשרים לו גישה למערכת.
            ידוע ללקוח ומוסכם כי האחריות הבלעדית על שמירת אבטחת הסיסמא האישית
            לשירותים המקוונים ולכתובת הדואר האלקטרוני ועל הגישה לטלפון הנייד של
            איש הקשר המורשה ו/או אבטחת פרטי הלקוח ו/או אנשי הקשר המורשים ו/או
            המשתמש ושמירה על הגישה לכניסה לאתר - מוטלת על הלקוח בלבד והוא פוטר
            את החברה ו/או הקבוצה מכל חבות ו/או אחריות בגין חשיפת פרטי הלקוח ו/או
            איש הקשר המורשים ו/או כל משתמש ו/או גישה בלתי מורשית. אם ימסור הלקוח
            את פרטי הזיהוי שלו באופן ישיר או עקיף לצד ג' - הקבוצה ו/או החברה לא
            יהיו אחראים לחשיפת מידע מהאתר ו/או ביצוע פעולות באתר. מובהר ללקוח כי
            חשיפת פרטים כאמור בין אם עקב אובדן ו/או גניבה ובין אם בכוונה, עלולה
            לחשוף מידע רגיש של הלקוח למשתמשים לא מורשים. בכל מקרה של חשד לחשיפה
            כזאת ו/או חשיפת הסיסמה האישית ופרטי הכניסה לאתר על הלקוח ועל אנשי
            הקשר המורשים מטעמו להחליף את פרטי איש הקשר המורשה בהקדם וליידע את
            החברה.
          </li>
          <li>
            אני מוותר/ת ויתור סופי ומוחלט על כל טענה ו/או תביעה נגד החברה ו/או
            נגד הקבוצה ו/או עובדיהם ו/או דירקטורים ו/או בעלי הקבוצה ו/או מי
            מטעמם בגין שימוש ו/או חשיפה לא מורשים במידע המופיע באתר ו/או
            בשירותים המקוונים כתוצאה ממסירה ו/או אובדן של הקוד האישי ושל הסיסמה
            האישית ו/או כתוצאה מצפייה במידע ללא מתן היתר מפורש לכך, לרבות צפייה
            במידע על-ידי בני משפחה.
          </li>
          <li>
            על המשתמש באתר מוטלת האחריות לגרום לכך שווירוסים לא יחדרו למערכת בה
            הוא עושה שימוש, והחברה פוטרת עצמה מכל אחריות לכך.{" "}
          </li>
        </ol>

        <br />
        <p>
          <strong>
            <u>המידע באתר </u>
          </strong>
        </p>
        <ol dir="rtl" style={{ marginRight: "2.5rem" }}>
          <li value="18">
            המידע וכל הדפים המצויים באתר הם רכושו הבלעדי של הקבוצה.
          </li>
          <li>
            החברה עושה מאמצים סבירים על מנת לכלול מידע מדויק ועדכני באתר, אולם
            מאחר והמידע משתנה לעיתים תדירות, החברה אינה יכולה להבטיח את מידת
            הדיוק של המידע ולכן וכל המסתמך על המידע באתר עושה זאת על אחריותו
            הוא.
          </li>
          <li>
            המידע המופיע באתר ו/או בפלטפורמות השונות של השירותים המקוונים שבו
            נסמך על המידע הקיים שהוזן למערכות המידע שבחברה והאתר בכללותו, כולל
            כל המידע המופיע בו, המערכות ו/או תוכנה שעליה מבוסס האתר, מידע וחומר
            שהגישה אליהם נעשית באמצעות האתר, מוצגים כמות שהם, נכון לרגע הציפייה
            ואולם ידוע ללקוח שלא כל המידע הרלוונטי בקשר ללקוח ועסקיו הקיים אצל
            החברה ו/או במערכות המידע של הקבוצה משוקף בכל רגע נתון באתר או נחשף
            בפלטפורמות השונות של השירותים המקוונים שבאתר. עוד ידוע ללקוח כי
            יתכנו פערים בין המידע העדכני ביותר והקיים בידי החברה ו/או עיכובים
            לבין המידע שבאתר או בהצגת פריטי מידע מסוימים באתר לרבות עדכון תעודות
            משלוח, תשלומים וכו' ומובהר ללקוח כי מידע על חשבוניות או משלוחים אינו
            בהכרח מייצג את כל המידע שבידי החברה או המידע העדכני ביותר ליום
            הצפייה ויתכן שהמידע הינו חלקי ו/או אינו שלם או מלא.
          </li>
          <li>
            אין להסתמך על המידע המופיע באתר; בכל מקרה של סתירה או אי התאמה בין
            המידע המופיע באתר לבין המידע שברשות החברה ו/או הקבוצה או כל מידע אחר
            האגור במערכות הקבוצה יקבע המידע שבידי הקבוצה ו/או המופיע במערכות
            הקבוצה על המידע שבאתר.
          </li>
          <li>
            תיתכן אפשרות שבמידע המופיע באתר, נפלו שיבושי הגהה, ניסוח, טעויות
            סופר וכו', למרות שהחברה עושה מאמצים למנוע זאת, החברה ו/או הקבוצה לא
            יהיו אחראים לנזק שנגרם עקב קיום שיבושים אלה. ידוע ללקוח כי ככל
            שקיימים בידיו מידע או נתונים נוספים על הנתונים המופיעים באתר ו/או
            במערכת השירותים המקוונים ו/או ככל שיגלה טעויות במידע המתייחס אליו
            המופיע באתר / מערכת השירותים המקוונים, חלה עליו האחריות ליידע את
            הגורמים הרלבנטיים בחברה, לרבות שירות הלקוחות של החברה, על מנת שהמידע
            האמור במערכות יהיה מלא שלם ומדויק ככל הניתן.
          </li>
          <li>
            האתר עשוי לאפשר העברת ו/או פרסום מסרים על ידי אנשי הקשר המורשים.
            מסרים אלה הינם באחריותו הבלעדית של הלקוח והקבוצה ו/או החברה ו/או כל
            צד שלישי לא יישאו בכל אחריות בגינם.
          </li>
          <li>
            ידוע ללקוח והלקוח ואנשי הקשר המורשים מסכימים כי ככל שיועלה לאתר ו/או
            למערכת השירותים המקוונים מידע / מסמכים ממקורות שונים שאינם החברה
            ו/או הקבוצה ו/או שלא הועלו לשירותים המקוונים על-ידי החברה, העלאה
            כאמור נעשית מיוזמת ועל אחריות הלקוח בלבד, והחברה והקבוצה לא יישאו
            באחריות כלשהי בגין העלאה כאמור ובגין האמור במידע/מסמכים שהועלו.
          </li>
          <li>
            באתר עשויים לפעול יישומים הצוברים מידע על פעילות המשתמש באתר,
            ומנתחים אותו לצורך שיפור השירות. מידע שנמסר על ידי איש קשר מורשה
            ו/או לקוח באתר עשוי להישמר במאגרי מידע, ולשמש לצורך מטרות מסחריות,
            עסקיות, משפטיות, פיתוח ושיפור השירותים ויתכן שיימסר לצדדים שלישיים
            ו/או לקבלני משנה של הקבוצה לטובת מטרות אלו.
          </li>
        </ol>

        <br />
        <p>
          <strong>
            <u>קניין רוחני </u>
          </strong>
        </p>
        <ol dir="rtl" style={{ marginRight: "2.5rem" }}>
          <li value="26">
            החברה הינה בעלת מלוא זכויות הקניין הרוחני באתר ותכניו, לרבות סימנים
            מסחריים, עיצוב האתר, תוכנה, יישום, טקסט, תמונות וכל תוכן אחר ומוסכם
            על הלקוח ואנשי הקשר המורשים, כי מלוא זכויות היוצרים, הקניין הרוחני
            וכל זכות אחרת בעיצוב האתר ו/או הפלטפורמות השונות של השירותים
            המקוונים ובכל תוכנה, יישום, קוד מחשב, קובץ גרפי, טקסט וכל חומר אחר
            הכלול באיזו מהן - הינן של הקבוצה בלבד.{" "}
          </li>
          <li>
            חל איסור לעשות שימוש כלשהו בסימנים המסחריים הנמצאים באתר ו/או
            בתמונות ו/או במידע הכלול בו, לרבות העתקה, שכפול, הפצה פרסום וכיו"ב.
            החברה מעניקה לך את טובת ההנאה מוגבלת ומותנית של גישה וצפייה בתכני
            האתר, אך ורק לשימושו של הלקוח. החברה רשאית לבטל טובת הנאה זו בכל
            זמן, לאחר או ללא מתן הודעה, על יסוד סיבה, או ללא כל סיבה.
          </li>
          <li>
            הסימנים המופיעים באתר הם סימני מסחר קנייניים של הקבוצה ואין לעשות כל
            פעולה שיש בה כדי לפגוע בזכויות הקניין בסימנים אלה. הלקוח מאשר ומצהיר
            כי ידוע לו שאין לעשות כל שימוש בסימני מסחר המופיעים ו/או העשויים
            להופיע בפלטפורמות השונות של השירותים המקוונים, לרבות סימני המסחר של
            הקבוצה השייכים לה ולה בלבד. האתר, השירותים שבו, המידע, ואלמנטים
            נוספים המתפרסמים בו עשויים להיות מוגנים על-פי דיני זכויות יוצרים
            בישראל ובחו"ל. אין להעתיק, לשנות, להפיץ, או לעשות שימוש מסחרי במידע,
            אלא ברשות בעלי הזכויות. ידוע ומוסכם על הלקוח כי חל איסור מוחלט
            להעתיק, להפיץ, להציג בפומבי או למסור לצד שלישי כל חלק מן הנ"ל בלא
            קבלת הסכמתה בכתב ומראש של החברה.{" "}
          </li>
        </ol>

        <br />
        <p>
          <strong>
            <u> אבטחת מידע </u>
          </strong>
        </p>
        <ol dir="rtl" style={{ marginRight: "2.5rem" }}>
          <li value="29">
            האחריות למדר, לפקח ולבקר ולעדכן את ההרשאות, את אבטחת המידע והשימוש
            הנעשה על ידי אנשי הקשר המורשים מטעם הלקוח מוטלת אך ורק על הלקוח.
            החברה לא תישא בכל חבות, והיא פטורה מכל אחריות, בקשר עם כל נזק, הפסד
            או הוצאה, מכל מין וסוג שהם, בין אם ישירים ובין אם עקיפים ו/או
            נסיבתיים ו/או תוצאתיים, אשר נגרמו ו/או ייגרמו ללקוח ו/או משתמשים
            ו/או לכל צד שלישי, בכל הקשור לכך והלקוח מתחייב לפצות ולשפות את החברה
            ואת הקבוצה בגין כל נזק כאמור (לרבות הוצאות משפט, מומחים ושכ"ט עוה"ד)
            מיד בדרישתה הראשונה.
          </li>
          <li>
            כל מערכת ממוחשבת לרבות האינטרנט, סובלת לעתים מתקלות. השימוש באתר
            ובאינטרנט ובפרט לקבלת מידע, חשוף לסיכונים הטבועים ברשת האינטרנט
            ובמערכות ממוחשבות המבוססות על תוכנות, חומרות ורשתות תקשורת לרבות
            לסיכונים הנובעים ממבנה רשת האינטרנט ומהשימוש בכל ציוד קצה אחר המאפשר
            התחברות לרשת ולסיכונים הנובעים מתוכנות מפגעות (וירוסים, סוסים
            טרויאנים וכדו'), ציתות לקווי תקשורת, פריצה על-ידי גורמים עוינים,
            התחזות לתוכנת האפליקציה או לאיזו מהמערכות והונאות מקוונות אחרות. אין
            אפשרות למנוע לחלוטין את התקלות והסיכונים האמורים. לפיכך, החברה
            והקבוצה תהינה פטורות מאחריות לכל נזק, הפסד או הוצאה כלשהם ו/או
            לשיבוש במידע המוצג באתר ו/או במערכות, העלולים להיגרם ללקוח כתוצאה,
            בין היתר, מהגורמים הבאים: הפסקות זמניות במתן השירותים בקווי תקשורת,
            ו/או משיבושים ותקלות אחרות בקווי התקשורת, ו/או שיבושים בפעולת האתר,
            זמינותו ו/או בזמני התגובה של המערכות הממוחשבות, ו/או משיבושים במידע
            ו/או בנתונים ו/או בהעברת ו/או בקליטת מסרים ו/או הוראות, כתוצאה
            מתקלות הנובעות מקווי תקשורת או תקלות אחרות שאינן בשליטת הקבוצה ו/או
            כשהקבוצה לא יכולה היתה למנען במאמץ סביר.
          </li>
          <li>
            ידוע ללקוח כי מטבעם השירותים המקוונים באתר תלויים בשירותי תקשורת
            ואחרים המסופקים לקבוצה ו/או לחברה על-ידי צדדים שלישיים (כגון: שרתי
            אינטרנט חיצוניים, ספקיות תשתיות אינטרנט, חברות סלולאר וכיו"ב), וכי
            יתכן שיחולו עיכובים בהופעת מידע בפלטפורמות השונות של השירותים
            המקוונים שבאתר מסיבות התלויות בצדדים שלישיים כאמור. הלקוח מצהיר
            ומאשר כי החברה והקבוצה לא תהינה אחראיות כלפי הלקוח ו/או מי מטעמו
            ו/או כל צד ג' בכל הקשור בעיכובים כאמור, וכי אין ולו ולא תהיה לו והוא
            מוותר/ת בזה על כל טענה ו/או דרישה ו/או עילה ו/או תביעה כנגד החברה
            והקבוצה בקשר עם עיכובים כאמור.
          </li>
        </ol>

        <br />
        <p>
          <strong>
            <u> שונות </u>
          </strong>
        </p>
        <ol dir="rtl" style={{ marginRight: "2.5rem" }}>
          <li value="32">
            הפעילות באתר זה וכל הקשור והכרוך בה, לרבות תנאי השימוש, יוכפפו לדין
            הישראלי לבד (ללא הפנייה לדין זר), וסמכות השיפוט הבלעדית בכל סכסוך
            הנוגע לאתר ולשימוש בו ו/או לפרשנות התקנון תהיה נתונה לבתי המשפט
            המוסמכים בתל-אביב.
          </li>
        </ol>

        <br />
        <p dir="rtl">
          <strong>
            © כל הזכויות שמורות ניאופרם. מעודכן 11.2023. גרסה 1.1. ט.ל.ח.
          </strong>
        </p>
        {/* </DialogContentText> */}
      </DialogContent>
    </Dialog>
  );
}
